import React from 'react'
import { HeaderContextType } from '../types'

export const HeaderContext = React.createContext<HeaderContextType<any>>({
  setColumnsWidth: undefined,
  columns: [],
  height: 0,
  hasStickyRightColumn: false
})
